import { useCallback } from 'react';

import { IFilterDefinition, OptionType } from '@evinced-private/ui-common';

import { useMobileScanFilters } from 'src/apps/mobile-common/hooks/useMobileScanFilters';
import { getMobileSdkSingleTestFilterDefinitions } from 'src/apps/mobile-sdk/pages/single-test/filters-section/MobileSdkSingleTestFilterDefinitions';
import { TMobileSdkTestFilterOptions } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';

interface UseMobileSdkSingleTestFiltersParams {
	allLabels: OptionType[];
	selectedLabels: OptionType[];
	filterOptions: TMobileSdkTestFilterOptions;
}

interface UseMobileSdkSingleTestFiltersReturn {
	filterDefinitions: IFilterDefinition[];
	mergedFilterOptions: TMobileSdkTestFilterOptions;
}

export const useMobileSdkSingleTestFilters = ({
	allLabels,
	selectedLabels,
	filterOptions
}: UseMobileSdkSingleTestFiltersParams): UseMobileSdkSingleTestFiltersReturn => {
	const getFilterDefinitions = useCallback(
		(
			scansLoadOptions: (searchText: string, callback: (options: OptionType[]) => void) => void,
			scansOptions: OptionType[]
		) => getMobileSdkSingleTestFilterDefinitions(scansLoadOptions, scansOptions),
		[]
	);

	return useMobileScanFilters({
		allScans: allLabels,
		selectedScans: selectedLabels,
		filterOptions,
		getFilterDefinitions
	});
};
